<template>
  <div class="grid grid-cols-3 gap-1.5">
    <button
      v-for="key in keys"
      :key="key"
      type="button"
      class="h-9 rounded-md text-sm font-medium tabular-nums bg-slate-50 text-slate-700 hover:bg-slate-100 active:bg-slate-200 dark:bg-slate-700 dark:text-slate-100 dark:hover:bg-slate-600"
      @click="$emit('press', key)"
    >
      {{ key }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'DialPad',

  data() {
    return {
      keys: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'],
    };
  },
};
</script>
